import {Stack, Typography} from "@mui/material"
import {FC} from "react"
import {NavLink} from "react-router-dom"
import {WarningIcon2} from "../../../assets"
import {Tooltip} from "../../atoms"
import {useTranslation} from "react-i18next"

type NavigationTab = {
  title: string
  link: string
  warningIcon?: boolean
}
type Props = {
  tabs: NavigationTab[]
}

const NavigationTabs: FC<Props> = (props) => {
  const {tabs} = props
  const {t} = useTranslation()
  return (
    <Stack
      direction="row"
      justifyContent={"space-between"}
      alignItems="end"
      width="100%"
    >
      <Stack
        component="header"
        direction="row"
        width="100%"
        height="48px"
        paddingX="32px"
        paddingTop="8px"
        paddingBottom="0"
        alignItems="flex-end"
        justifyContent="flex-start"
        bgcolor="#ffffff"
        borderBottom="1px solid #1c1c1c19"
      >
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"center"}
          sx={{marginBottom: "1px"}}
        >
          {tabs.map((tab, i) => (
            <NavLink
              to={tab.link}
              end
              key={i}
              style={{
                textDecoration: "none",
              }}
            >
              {({isActive}) => (
                <Stack
                  paddingX="32px"
                  paddingY="8px"
                  alignItems="center"
                  justifyContent="center"
                  borderBottom={isActive ? "4px solid #053747" : "inherit"}
                  sx={{cursor: "pointer"}}
                  flexDirection={"row"}
                  gap={"8px"}
                >
                  <Typography
                    fontSize="16px"
                    fontWeight="700"
                    lineHeight="1.5"
                    color="#053747"
                    sx={{
                      textDecoration: "none",
                    }}
                  >
                    {tab.title}
                  </Typography>
                  {tab.warningIcon && (
                    <Tooltip
                      title={t("Please update your preferences")}
                      arrow
                      placement="right"
                    >
                      <Stack>
                        <WarningIcon2
                          fill="#f98500"
                          height={"20px"}
                          width={"20px"}
                        />
                      </Stack>
                    </Tooltip>
                  )}
                </Stack>
              )}
            </NavLink>
          ))}
        </Stack>
      </Stack>
    </Stack>
  )
}

NavigationTabs.displayName = "NavigationTabs"

export default NavigationTabs
